import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { TrackerFile } from '../models/tracker-file';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  protected apiUrl: string;
  protected apiScope: string;
  protected graphScopes: string[];

  constructor() {
    this.apiUrl = environment.apiUrl;
    this.apiScope = environment.apiScope;
    this.graphScopes = environment.graphScopes;
  }

  protected handleError(error: HttpErrorResponse) {
    let message = "An unexpected error occurred"

    // Handle Application Errors
    if (error.error.title && error.error.detail)
      message = `${error.error.title}: ${error.error.detail}`

    // Handle Validation Errors
    if (error.error.errors) {
      message = error.error.title
    }

    console.error(error)
    return throwError(() => message)
  }

  protected handleFile(response: any): TrackerFile {
    const disposition = response.headers.get('Content-Disposition') as string;
    let filename = disposition.split(';')[1].split('=')[1];

    return {
      filename: filename,
      data: new Blob([response.body], {type: response.type})
    } as TrackerFile;
  }
}
